import { useMutation, useQuery } from "@apollo/client";
import { get } from "lodash";
import moment from "moment";
import "moment/locale/fr";
import { useContext, useState } from "react";
import { StoreContext } from "shared/store";
import {
  CREATE_EVENT,
  DELETE_EVENT,
  UPDATE_EVENT,
} from "utils/api/graphql/mutations/events";
import { EVENTS } from "utils/api/graphql/queries/events";
import View from "./View";

const List = () => {
  moment.locale("fr");
  const { user } = useContext(StoreContext);

  const [pagination, setPagination] = useState({ skip: null, take: null });

  const [filter, setFilter] = useState({
    gt: { startDate: moment().startOf("week").toDate() },
    lt: { startDate: moment().endOf("week").toDate() },
    where: { reminder: { user: { id: get(user, "id", null) } } },
  });

  const { data, loading } = useQuery(EVENTS, {
    variables: { ...filter, ...pagination },
  });

  const [addEvent] = useMutation(CREATE_EVENT, {
    refetchQueries: [
      {
        query: EVENTS,
        awaitRefetchQueries: true,
        variables: { ...filter, ...pagination },
      },
    ],
  });
  const [updateEvent] = useMutation(UPDATE_EVENT, {
    refetchQueries: [
      {
        query: EVENTS,
        awaitRefetchQueries: true,
        variables: { ...filter, ...pagination },
      },
    ],
  });
  const [deleteEvent] = useMutation(DELETE_EVENT, {
    refetchQueries: [
      {
        query: EVENTS,
        awaitRefetchQueries: true,
        variables: { ...filter, ...pagination },
      },
    ],
  });

  return (
    <View
      data={get(data, "events.data", [])}
      setValues={setPagination}
      skip={pagination.skip || 0}
      addEvent={addEvent}
      updateEvent={updateEvent}
      deleteEvent={deleteEvent}
      user={user}
      setFilter={setFilter}
    />
  );
};

export default List;
